import { useSyncExternalStore } from 'react';
import { setMediaSession, clearMediaSession } from '@/lib/backgroundAudio';

// App-wide list of sounds currently playing (metronomes, click, drone) + lock-screen controls.
const sounds = new Map();
const subs = new Set();
let snapshot = [];

const syncMediaSession = () => {
  if (!snapshot.length) { clearMediaSession(); return; }
  setMediaSession({
    title: snapshot.map((s) => s.label).join(' + '),
    artist: 'Metronomo · Maurizio "Pink" Rosa',
    onStop: () => activeSounds.stopAll(),
  });
};

const emit = () => {
  snapshot = [...sounds.values()];
  subs.forEach((fn) => fn());
  syncMediaSession();
};

export const activeSounds = {
  set(id, sound) { sounds.set(id, { id, ...sound }); emit(); },
  remove(id) { if (sounds.delete(id)) emit(); },
  stopAll() { [...sounds.values()].forEach((s) => s.stop()); },
  subscribe(fn) { subs.add(fn); return () => subs.delete(fn); },
  get: () => snapshot,
};

export const useActiveSounds = () => useSyncExternalStore(activeSounds.subscribe, activeSounds.get);
